<template>
  <v-app>
    <navigation />
    <notification />
    <v-content>
      <transition name="fade">
        <router-view v-show="!isLoading" />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import Navigation from './ui/components/Navigation.vue';
import Notification from './ui/components/Notification.vue';

export default {
  name: 'App',
  components: {
    Navigation,
    Notification,
  },

  data() {
    return {
      isLoading: false,
    };
  },

  watch: {
    $route(to) {
      if (this.$route.query.auth_token) {
        this.setParams(to.query);
      }
    },
  },

  methods: {
    ...mapActions('app', ['setParams']),
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
